import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import { typeInfo } from "../../../../../constants/typeInfo";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import CommonPage from "../../common/CommonPage";

const OXPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [overlayVisible, setOverlayVisible] = useState(false);

  const currentPage = pageList[currentIndex] || {
    type: "",
    data: {},
  };

  const buttonList = ["O", "X"];
  const buttonInfo = {
    O: {
      backgroundColor: "rgba(67, 140, 251, 0.15)",
      color: "rgba(67, 140, 251, 1)",
    },
    X: {
      backgroundColor: "rgba(255, 68, 68, 0.1)",
      color: "rgba(255, 68, 68, 1)",
    },
  };

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }
    setPageList(
      section.question.data.map((question) => {
        return {
          ...question,
          answer: question.answer.split(" ")[0],
          comment: question.answer.split("(")[1].split(")")[0],
          isSubmitted: false,
        };
      })
    );
  }, [section]);

  const clickOX = (OX) => {
    if (currentPage.isSubmitted) return;

    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          input: OX,
          isSubmitted: true,
        };
      } else {
        return page;
      }
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setOverlayVisible(true);
    setTimeout(() => {
      setOverlayVisible(false);
    }, 600);
  };

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      let isAllAnswered = true;

      pageList.forEach((page, index) => {
        if (!page.isSubmitted) {
          isAllAnswered = false;
        }
      });

      if (isAllAnswered) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      totalNo={pageList.length}
      paragraph={section?.question.full_text}
      currentPage={currentPage}
      overlayVisible={overlayVisible}
      isCorrect={currentPage.answer === currentPage.input}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "50px",
        }}
      >
        <div
          style={{
            fontSize: "20px",
          }}
        >
          {"본문의 내용과 일치하면 O, 일치하지 않으면 X를 고르시오."}
        </div>
        <div
          style={{
            fontSize: "28px",
            textAlign: "center",
            lineHeight: "1.5",
          }}
        >
          {currentPage.question}
        </div>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            flexDirection: "row",
            gap: "30px",
          }}
        >
          {buttonList.map((OX) => {
            return (
              <button
                style={{
                  height: "50px",
                  width: "120px",
                  fontSize: "24px",
                  borderRadius: "5px",
                  backgroundColor: currentPage.isSubmitted
                    ? currentPage.input === OX
                      ? currentPage.answer === OX
                        ? typeInfo["comprehensive"].color
                        : "#FF4444"
                      : currentPage.answer === OX
                      ? typeInfo["comprehensive"].color
                      : buttonInfo[OX].backgroundColor
                    : buttonInfo[OX].backgroundColor,
                  color:
                    currentPage.isSubmitted &&
                    (currentPage.input === OX || currentPage.answer === OX)
                      ? "white"
                      : buttonInfo[OX].color,
                  border: currentPage.isSubmitted
                    ? currentPage.input === OX
                      ? currentPage.answer === OX
                        ? "1px solid " + typeInfo["comprehensive"].color
                        : "1px solid #FF4444"
                      : currentPage.answer === OX
                      ? "1px solid " + typeInfo["comprehensive"].color
                      : "1px solid " + buttonInfo[OX].color
                    : "1px solid " + buttonInfo[OX].color,
                  transition: "all 0.3s",
                }}
                onClick={() => clickOX(OX)}
              >
                {OX}
              </button>
            );
          })}
        </div>
      </div>
    </CommonPage>
  );
};

export default OXPage;
